export default {"src":"/_next/static/media/BACK_ICON.5baa15ad.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};